<template>
	<div>
		<b-row>
			<b-col cols="12" class="mb-2">
				<h3 class="mb-0 text-center titulo-tab">
					Documentos Necessários
				</h3>
			</b-col>
		</b-row>

		<b-row>
			<b-col cols="12" class="mb-2">
				<h4>
					Documentos do Cedente (quem está vendendo):
				</h4>
			</b-col>
			<b-col cols="12" class="mb-2">
				<b-col cols="12" class="mb-2">
					<h6>
						Documentos Pessoais:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - CNH válida (não vencida, completa e legível) ou RG e CPF (frente e verso).</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<h6>
						Estado Civil:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Solteiro: Certidão de Nascimento atualizada (emissão até 90 dias);</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - União Estável: Certidão de Nascimento atualizada (emissão até 90 dias);</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Casado: Certidão de Casamento;</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Divorciado ou Viúvo: Certidão de Casamento atualizada (emissão até 90 dias,
							com a
							devida averbação);</p>
					</div>
				</b-col>
			</b-col>
		</b-row>

		<b-row>
			<b-col cols="12" class="mb-2">
				<h4>
					Documentos do Cônjuge do Cedente (se aplicável):
				</h4>
			</b-col>
			<b-col cols="12" class="mb-2">
				<b-col cols="12" class="mb-2">
					<h6>
						Documentos Pessoais:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - CNH válida (não vencida, completa e legível) ou RG e CPF (frente e verso).</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<h6>
						Informações:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - E-mail pessoal: não aceitamos e-mail corporativo ou de terceiros. Conter
							nome/sobrenome;</p>
					</div>
				</b-col>

				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Profissão;</p>
					</div>
				</b-col>

				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Dois números de telefone/celular;</p>
					</div>
				</b-col>

				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Chave PIX pessoal (não aceitamos chave PIX de terceiros).</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<h6>
						Observação: Em caso de alteração de nome, enviar documento atualizado com o novo nome e assinatura.
					</h6>
				</b-col>
			</b-col>
		</b-row>

		<b-row>
			<b-col cols="12" class="mb-2">
				<h4>
					Documentos do Cessionário (quem está Comprando):
				</h4>
			</b-col>
			<b-col cols="12" class="mb-2">
				<b-col cols="12" class="mb-2">
					<h6>
						Documentos Pessoais:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - CNH válida (não vencida, completa e legível) ou RG e CPF (frente e verso).</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Comprovante de residência: documento legível.</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<h6>
						Estado Civil:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Solteiro: Certidão de Nascimento atualizada;</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - União Estável: Declaração de União Estável emitida em cartório.</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Casado: Certidão de Casamento;</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Divorciado ou Viúvo: Certidão de Casamento com Averbação de Divórcio ou Óbito;</p>
					</div>
				</b-col>
			</b-col>
		</b-row>

		<b-row>
			<b-col cols="12" class="mb-2">
				<h4>
					Documentos do Cônjuge do Cessionário (se aplicável):
				</h4>
			</b-col>
			<b-col cols="12" class="mb-2">
				<b-col cols="12" class="mb-2">
					<h6>
						Documentos Pessoais:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - CNH válida (não vencida, completa e legível) ou RG e CPF (frente e verso).</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<h6>
						Informações:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - E-mail pessoal: não aceitamos e-mail corporativo ou de terceiros. Conter
							nome/sobrenome;</p>
					</div>
				</b-col>

				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Profissão;</p>
					</div>
				</b-col>

				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Número de telefone/celular.</p>
					</div>
				</b-col>

				<b-col cols="12" class="mb-2">
					<h6>
						Observação: Em caso de alteração de nome, enviar documento atualizado com o novo nome e assinatura.
					</h6>
				</b-col>
			</b-col>
		</b-row>

		<b-row>
			<b-col cols="12" class="mb-2">
				<h4>
					Pessoa Jurídica (Cedente e/ou Cessionário)
				</h4>
			</b-col>
			<b-col cols="12" class="mb-2">
				<b-col cols="12" class="mb-2">
					<h6>
						Documentos da Empresa:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Cartão CNPJ;</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Contrato Social;</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Alteração Contratual mais recente (se aplicável): deve estar de acordo com a Certidão Simplificada;</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Certidão Simplificada: documento emitido a menos de 30 dias;</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Comprovante de Endereço da Empresa.</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<h6>
						Informações:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - E-mail empresarial;</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Dois números de telefone/celular.</p>
					</div>
				</b-col>
			</b-col>
		</b-row>

		<b-row>
			<b-col cols="12" class="mb-2">
				<h4>
					Representante(s) Legal(is)
				</h4>
			</b-col>
			<b-col cols="12" class="mb-2">
				<b-col cols="12" class="mb-2">
					<h6>
						Documentos Pessoais:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - CNH válida (não vencida, completa e legível) ou RG e CPF (frente e verso).</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Comprovante de residência: documento legível.</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<h6>
						Estado Civil:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Solteiro: Certidão de Nascimento atualizada (emissão até 90 dias);</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - União Estável: Certidão de Nascimento atualizada (emissão até 90 dias);</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Casado: Certidão de Casamento;</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Divorciado ou Viúvo: Certidão de Casamento atualizada (emissão até 90 dias e com a devida averbação);</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<h6>
						Informações:
					</h6>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - E-mail pessoal: não aceitamos e-mail corporativo ou de terceiros. Conter nome/sobrenome;</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Profissão;</p>
					</div>
				</b-col>
				<b-col cols="12" class="mb-2">
					<div class="d-flex text-left my-1 align-items-center">
						<p class="requisito"> - Dois números de telefone/celular.</p>
					</div>
				</b-col>
				
				<b-col cols="12" class="mb-2">
					<h6>
						Observação: Em caso de alteração de nome, enviar documento atualizado com o novo nome e assinatura.
					</h6>
				</b-col>
			</b-col>
		</b-row>

	</div>
</template>
<style scoped>
.requisito {
	margin: 0;
	width: 90%;
}

.titulo-tab {
	margin-bottom: 50px !important;
}
</style>

<script>
import {
	BRow,
	BCol,
} from 'bootstrap-vue'

export default {
	name: 'TabDocumentos',
	components: {
		BRow,
		BCol,
	},
}
</script>
